// extracted by mini-css-extract-plugin
module.exports = {"label_spec":"closeWarning_label_spec__340nK","warning":"closeWarning_warning__3Sp9k","acces_err_warning":"closeWarning_acces_err_warning__2Eq9e"};